const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Team Activity Resource: the manager dashboard's activity stats, limited by continu-api to the
 * caller's team (analyze refuses user_list to managers).
 * @argument {$resource} $resource injected to define a resource api
 */
app.factory('TeamActivity', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/team-activity/:resource/:id/:subresource', null, {
    recent: {params: {resource: 'recent'}, method: 'GET', isArray: true},
    totals: {params: {resource: 'totals'}, method: 'GET', isArray: false},
    userCounts: {params: {resource: 'users', subresource: 'counts'}, method: 'GET', isArray: false},
    contentCounts: {params: {resource: 'content', subresource: 'counts'}, method: 'GET', isArray: false}
  });
}]);
